import { createRoot } from "react-dom/client";
import * as Sentry from '@sentry/react';

import App from "./App.tsx";
import "./index.css";
import "./styles/local-fonts.css";
import "./i18n";





// ─── VITE ENV DEBUG ───
// Only logs in development; harmless in prod (VITE_ vars are public by design)
if (import.meta.env.DEV) {
  const viteEnv: Record<string, string> = {};
  for (const [k, v] of Object.entries(import.meta.env)) {
    viteEnv[k] = typeof v === "string" && v.length > 40 ? v.slice(0, 12) + "…[truncated]" : String(v ?? "");
  }
  console.group("[env] Vite env vars");
  console.table(viteEnv);
  console.log("[env] VITE_SUPABASE_URL:", import.meta.env.VITE_SUPABASE_URL ?? "⚠️ NOT SET");
  console.log("[env] VITE_SUPABASE_PUBLISHABLE_KEY:", import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY ? "✅ set" : "⚠️ NOT SET");
  console.log("[env] VITE_SUPABASE_PROJECT_ID:", import.meta.env.VITE_SUPABASE_PROJECT_ID ?? "⚠️ NOT SET");
  console.log("[env] VITE_STORAGE_BACKEND:", import.meta.env.VITE_STORAGE_BACKEND ?? "⚠️ NOT SET");
  console.log("[env] MODE:", import.meta.env.MODE);
  console.groupEnd();
}

if(import.meta.env.VITE_SENTRY_DSN) { 
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true
  });
}

createRoot(document.getElementById("root")!).render(<App />);
